import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { Redirect } from 'react-router-dom';

import { MODAL_NAME } from 'Components/Auth/AuthModal';
import { PASSWORD_UPDATE_KEY } from 'Components/Auth/AuthModal/PasswordUpdateForm';

class PasswordResetLandingPage extends Component {
  componentDidMount() {
    const { openModal, match: { params: { resetToken } } } = this.props;
    openModal(MODAL_NAME, { formToDisplay: PASSWORD_UPDATE_KEY, resetToken });
  }

  render() {
    return <Redirect to="/" from="/" />;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openModal: actions.openModal,
    },
    dispatch
  );
}

export default connect(undefined, mapDispatchToProps)(PasswordResetLandingPage);



// WEBPACK FOOTER //
// ./src/Components/Pages/Auth/PasswordResetLandingPage.js